module.exports = __webpack_public_path__ + "media/images/nav_icons/articles-ed0a17ff2518c47c5052799bb62dc0d0.png";